<template>
  <Loading v-if="loading" />
  <DialogBox v-else :title="is_pt_br ? 'Excluir imagens' : 'Delete images'" @close="$emit('close')">
    <template>
      <legend>
        {{
          is_pt_br
            ? `Deseja excluir as imagens para renderização do 3D do bloco ${name} ?`
            : `Do you want to delete images for tile 3D rendering ${name}`
        }}
      </legend>
    </template>
    <template v-slot:footer>
      <button
        @click.prevent="handleDelete"
        class="w-100 mt-1 btn btn-outline-danger"
      >
       {{is_pt_br ?  'Excluir' : 'Deletye'}}
      </button>
    </template>
  </DialogBox>
</template>

<script>
import DialogBox from "../utils/DialogBox.vue";
import Loading from "../utils/AnimateLoad.vue";
import { mapActions } from "vuex";
export default {
  name: "DeleteImge3D",
  props: { stone_id: Number, name: String },
  data() {
    return {
      loading: false,
    };
  },
  components: { DialogBox, Loading },
  computed: {
    is_pt_br() {
      return this.$store.getters.is_pt_br;
    },
  },
  methods: {
    ...mapActions("stone", ["deleteImg3D"]),
    async handleDelete() {
      this.loading = true;
      await this.deleteImg3D(this.stone_id)
        .then((res) => {
          this.$emit("deleted", null);
        })
        .catch((error) => {
          this.$emit("deleted", error);
        });

      this.loading = false;
    },
  },
};
</script>
